import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AuthService, SessionService } from 'src/app/services';

@Component({
  selector: 'app-global-session',
  templateUrl: './global-session.component.html',
  styleUrls: ['./global-session.component.scss']
})
export class GlobalSessionComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router, public dialogRef: MatDialogRef<GlobalSessionComponent>,
    private session: SessionService, public dialog: MatDialog, private authService: AuthService) { }

  ngOnInit(): void { }

  startAfresh() {
    this.router.navigate(['/'], { relativeTo: this.route });
    this.dialogRef.close();
  }
  
  continue() {
    // window.location.reload();
    if(this.authService.loggedIn()) {
      this.router.navigate(['./u/flights/search'], { relativeTo: this.route });
    } else {
      this.router.navigate(['search'], { relativeTo: this.route });
    }
    this.dialogRef.close();
    this.session.trackUserActivity();
    const logoutTimeout = this.session.getLogoutTimeout(); // Get the logout timeout duration
    setTimeout(() => {
      this.dialog.open(GlobalSessionComponent, {
        panelClass: 'session-dialog-container',
        width: '100%',
        maxWidth:'520px',
        disableClose: true,
      });
      // console.log('Session timeout after 15 seconds of inactivity');
      // Add your logout logic here
    }, logoutTimeout);
  } 
}
